exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rigth-column{float:right;padding-top:10px}.rigth-column img{width:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-f33ff714!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 52
// module chunks = 0